import React from 'react';
import { Text } from '@react-pdf/renderer';
import { getFontFamily } from '../../../badge/pdf/utils';

interface Props {
  style?: any,
  children: string;
  bold?: boolean
}

export const TextWithFontCheck: React.FC<Props> = ({ children, style, bold }) => {
  const value = (children || '').normalize('NFC');
  return (
    <Text>
      {
        (value || '').split('').map((str, i) => <Text
          key={str + i}
        style={[style || {}, getFontFamily(str, { bold })]}>{str}</Text>)
      }
    </Text>
  );
};
